import { useEffect } from 'react';
import { TableConfigDto } from '@asset-metrix/portal-gateway-client-js';
import { CheckButton } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../../store';

import styles from './workflowStateFilters.module.scss';

export type WorkflowStateFilterProps = {
  config?: Pick<TableConfigDto, 'workflowStateSelectionConfig'>;
  widgetFilterInstanceId: string;
};

export const WorkflowStateFilters = ({
  config,
  widgetFilterInstanceId,
}: WorkflowStateFilterProps) => {
  const [stateSelections, addSelection, removeSelection, initSelection] =
    useStore(
      useShallow((state) => [
        state.workflowStateSelections,
        state.addWorkflowStateSelection,
        state.removeWorkflowStateSelection,
        state.initWorkflowStateSelection,
      ])
    );

  useEffect(() => {
    if (config?.workflowStateSelectionConfig) {
      initSelection(
        widgetFilterInstanceId,
        config?.workflowStateSelectionConfig
      );
    }
  }, [
    config?.workflowStateSelectionConfig,
    initSelection,
    widgetFilterInstanceId,
  ]);

  if (!stateSelections[widgetFilterInstanceId]) {
    return null;
  }

  return (
    <div data-testid="workflow state filters" className={styles['row']}>
      {config?.workflowStateSelectionConfig?.options?.map((filter) => (
        <CheckButton
          key={filter.label}
          initiallyChecked={Boolean(
            stateSelections[widgetFilterInstanceId]?.find(
              (s) => s.label === filter.label
            )
          )}
          onClick={(newState) => {
            if (newState) {
              addSelection(widgetFilterInstanceId, filter);
            } else {
              removeSelection(widgetFilterInstanceId, filter.label);
            }
          }}
        >
          {filter.label}
        </CheckButton>
      ))}
    </div>
  );
};
